import React from 'react';

import { LazyBreadcrumb } from '@europrocurement/flexy-components';

import { useWebsocket, WebsocketPayloadMessage } from '@europrocurement/l2d-websocket';
import WidgetsFrame from './WidgetsFrame/WidgetsFrame';

const Accueil = function () {
    const websocketMethods = useWebsocket();

    const socketMethods = websocketMethods(
        'toto',
        'messagerie_dossier_formalite',
        (data: WebsocketPayloadMessage) => {
            console.log('Message reçu dans Accueil:', data);
        },
    );

    console.log('Socket methods:', socketMethods);

    return (
        <>
            <LazyBreadcrumb path={[{ path: 'Accueil', link: '/accueil' }, 'Dashboard']} />

            <WidgetsFrame />
        </>
    );
};
export default Accueil;
